<template>
  <div class="grid-content">
    <div class="loading" v-loading="loading">
      <el-table :data="dataList">
        <el-table-column prop="teacherGradeName" label="一对一" width="120">
        </el-table-column>
        <el-table-column v-for="item in studentGradeList" :prop="item.Name" :key="item.Key" :label="item.Label" width="130">
          <template slot-scope="scope">
            <el-input placeholder="请输入价格" size="small" oninput="value=value.replace(/[^0-9.]/g,'')"
              onblur="value=!!value?value.toNumber().toFixedEx(2):null"
              v-model="scope.row[item.Name]" class="input-width">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-row v-if="!options.isReadonly" class="cs-filter-row">
      <el-col :span="4" class="footer-left">
        <el-button size="medium" :disabled="loading" :type="submitBtnClass" @click="onSave">保存更新</el-button>
      </el-col>
      <el-col :span="16" class="footer-right">
        <el-alert :closable="false" v-show="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
    padding-right: 10px;
  }

  .el-input {
    text-align-last: center;
    min-width: 120px;
    width: 50%;
  }

  .el-form-item {
    margin-left: 10px;
  }
}
</style>

<script>
import {
  getVipCoursePrices,
  saveVipCoursePrice,
} from "@/service/globalPriceSetting.service";
import {
  getStudentGradeList,
  getTeacherGradeList,
} from "@/service/common.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean,
    },
  },
  data() {
    return {
      isLoadedData: false,
      loading: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      dataList: [],
      studentGradeList: [],
      teacherGradeList: [],
      vipCoursePrices: [],
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadDataList();
  },
  updated() {},
  methods: {
    loadDataList() {
      if (!this.isActive) {
        return;
      }
      this.loading = true;
      getStudentGradeList().then((result) => {
        if (result && result.success) {
          this.studentGradeList = result.data;
          this.checkDataLoaded();
        } else {
          this.loading = false;
          this.isLoadedData = true;
        }
      });
      getTeacherGradeList().then((result) => {
        if (result && result.success) {
          this.teacherGradeList = result.data;
          this.checkDataLoaded();
        } else {
          this.loading = false;
          this.isLoadedData = true;
        }
      });
      getVipCoursePrices()
        .then((result) => {
          if (result && result.success) {
            this.vipCoursePrices = result.data;
            this.checkDataLoaded();
          } else {
            this.loading = false;
            this.isLoadedData = true;
          }
        })
        .catch((ex) => {
          this.loading = false;
          this.isLoadedData = true;
        });
    },
    checkDataLoaded() {
      if (
        this.studentGradeList.length > 0 &&
        this.teacherGradeList.length > 0 &&
        this.vipCoursePrices.length > 0
      ) {
        this.loading = false;
        this.isLoadedData = true;
        let list = [];
        for (let i = 0; i < this.teacherGradeList.length; i++) {
          let model = {
            teacherGrade: this.teacherGradeList[i].Key,
            teacherGradeName: this.teacherGradeList[i].Label,
          };

          for (let j = 0; j < this.studentGradeList.length; j++) {
            let item = this.vipCoursePrices.find(
              (x) =>
                x.TeacherGrade == this.teacherGradeList[i].Key &&
                x.StudentGrade == this.studentGradeList[j].Key
            );
            if (item) {
              model[this.studentGradeList[j].Name] = item.Price;
            } else {
              model[this.studentGradeList[j].Name] = 0;
            }
          }
          list.push(model);
        }
        this.dataList = list;
      }
    },
    onSave() {
      
      for (let i = 0; i < this.teacherGradeList.length; i++) {
        let model = this.dataList.find(
          (x) => x.teacherGrade == this.teacherGradeList[i].Key
        );
        for (let j = 0; j < this.studentGradeList.length; j++) {
          let item = this.vipCoursePrices.find(
            (x) =>
              x.TeacherGrade == this.teacherGradeList[i].Key &&
              x.StudentGrade == this.studentGradeList[j].Key
          );
          if (item) {
            item.Price = model[this.studentGradeList[j].Name];
          }
        }
      }
   
      this.showError = false;
      this.loading = true;
      saveVipCoursePrice(this.vipCoursePrices)
        .then((result) => {
          if (!!result && result.success) {
            this.$message.success("保存成功！");
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.loadDataList();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/vipCoursePrice.vue